const config = {
        // apiUrl: "https://oceanapi.fiveytech.com"
          apiUrl: "https://apiodc.cloudgentechnologies.com"
}
export default config;